import { css } from 'lit';

export const styles = css`
	:host {
		--_sds-notification-background-color: var(--sds-notification-background-color, var(--sds-color-alert-info-surface-tinted));

		--_sds-notification-border-color: var(--sds-notification-border-color, var(--sds-color-alert-info-border-default));
		--_sds-notification-border-radius: var(--sds-notification-border-radius, var(--sds-radius-sm));
		--_sds-notification-border-width: var(--sds-notification-border-width, var(--sds-border-sm));

		--_sds-notification-column-gap: var(--sds-notification-column-gap, var(--sds-spacing-2xs));
		--_sds-notification-content-gap: var(--sds-notification-content-gap, var(--sds-spacing-3xs));

		--_sds-notification-font-family: var(--sds-notification-font-family, var(--sds-typography-font-family-roboto));
		--_sds-notification-font-size: var(--sds-notification-font-size, var(--sds-components-font-size-content-md));
		--_sds-notification-font-weight: var(--sds-notification-font-weight, var(--sds-typography-body-md-desktop-font-weight));
		--_sds-notification-line-height: var(--sds-notification-line-height, var(--sds-components-line-height-squeezed-md));
		--_sds-notification-text-color: var(--sds-notification-text-color, var(--sds-color-alert-info-text-default));

		--_sds-notification-title-font-size: var(--sds-notification-title-font-size, var(--sds-typography-body-lg-desktop-tall-font-size));
		--_sds-notification-title-font-weight: var(--sds-notification-title-font-weight, var(--sds-typography-body-lg-strong-tall-desktop-font-weight));
		--_sds-notification-title-line-height: var(--sds-notification-title-line-height, var(--sds-typography-body-lg-strong-tall-desktop-line-height));

		--_sds-notification-icon-color: var(--sds-notification-icon-color, var(--sds-color-alert-info-text-subtle));
		--_sds-notification-max-line-width: var(--sds-notification-max-line-width, var(--sds-typography-max-line-width));
		--_sds-notification-padding: var(--sds-notification-padding, var(--sds-spacing-sm));
		--_sds-notification-remove-btn-radius: var(--sds-notification-remove-btn-radius, var(--sds-radius-xs));

		display: block;
	}

	.sds-notification {
		display: flex;
		gap: var(--_sds-notification-column-gap);
		padding: var(--_sds-notification-padding);

		background-color: var(--_sds-notification-background-color);
		border: var(--_sds-notification-border-width) solid var(--_sds-notification-border-color);
		border-radius: var(--_sds-notification-border-radius);
		color: var(--_sds-notification-text-color);

		font-family: var(--_sds-notification-font-family);
		text-align: left;
	}

	.sds-notification__type {
		color: var(--_sds-notification-icon-color);
	}

	.sds-notification__content {
		align-self: center;
		display: flex;
		flex: 1;
		flex-direction: column;
		gap: var(--_sds-notification-content-gap);
	}

	.sds-notification__actions {
		--sds-button-padding-inline: 0;
	}

	.sds-notification__icon {
		display: block;
		position: relative;
		z-index: 1;
	}

	:host([variant='success']) {
		--_sds-notification-background-color: var(--sds-notification-background-color, var(--sds-color-alert-success-surface-tinted));
		--_sds-notification-border-color: var(--sds-notification-border-color, var(--sds-color-alert-success-border-default));
		--_sds-notification-text-color: var(--sds-notification-text-color, var(--sds-color-alert-attention-text-default));
		--_sds-notification-icon-color: var(--sds-notification-icon-color, var(--sds-color-alert-success-text-subtle));

		sds-button {
			--sds-button-text-color: var(--sds-color-alert-success-action-default);
		}

		sds-button:hover {
			--sds-button-background-color: var(--sds-color-alert-success-surface-hover);
			--sds-button-border-color: var(--sds-color-alert-success-surface-hover);
		}

		sds-button:active {
			--sds-button-background-color: var(--sds-color-alert-success-surface-active);
			--sds-button-border-color: var(--sds-color-alert-success-surface-active);
		}
	}

	:host([variant='warning']), /* Deprecated */
	:host([variant='attention']) {
		--_sds-notification-background-color: var(--sds-notification-background-color, var(--sds-color-alert-attention-surface-tinted));
		--_sds-notification-border-color: var(--sds-notification-border-color, var(--sds-color-alert-attention-border-default));
		--_sds-notification-text-color: var(--sds-notification-text-color, var(--sds-color-alert-attention-text-default));
		--_sds-notification-icon-color: var(--sds-notification-icon-color, var(--sds-color-alert-attention-text-subtle));

		sds-button {
			--sds-button-text-color: var(--sds-color-alert-attention-border-default);
		}

		sds-button:hover {
			--sds-button-background-color: var(--sds-color-alert-attention-surface-hover);
			--sds-button-border-color: var(--sds-color-alert-attention-surface-hover);
		}

		sds-button:active {
			--sds-button-background-color: var(--sds-color-alert-attention-surface-active);
			--sds-button-border-color: var(--sds-color-alert-attention-surface-active);
		}
	}

	:host([variant='critical']), /* Deprecated */
	:host([variant='danger']) {
		--_sds-notification-background-color: var(--sds-notification-background-color, var(--sds-color-alert-danger-surface-tinted));
		--_sds-notification-border-color: var(--sds-notification-border-color, var(--sds-color-alert-danger-border-default));
		--_sds-notification-text-color: var(--sds-notification-text-color, var(--sds-color-alert-danger-text-default));
		--_sds-notification-icon-color: var(--sds-notification-icon-color, var(--sds-color-alert-danger-text-subtle));
	}

	::slotted([slot='title']),
	::slotted(:is(h1, h2, h3, h4, h5, h6)) {
		color: var(--_sds-notification-text-color) !important;
		font-size: var(--_sds-notification-title-font-size) !important;
		font-style: normal !important;
		font-weight: var(--_sds-notification-title-font-weight) !important;
		line-height: var(--_sds-notification-title-line-height) !important;
		margin: 0 !important;
		max-width: var(--_sds-notification-max-line-width) !important;
	}

	::slotted([slot='message']),
	::slotted(:is(p)) {
		color: var(--_sds-notification-text-color) !important;
		font-size: var(--_sds-notification-font-size) !important;
		font-style: normal !important;
		font-weight: var(--_sds-notification-font-weight) !important;
		line-height: var(--_sds-notification-line-height) !important;
		margin: 0 !important;
		max-width: var(--_sds-notification-max-line-width) !important;
	}
`;
